import React from "react";
import axios from "axios";
import { useSubmit } from "react-router";
import {
    renderLoadingProgressToast,
    renderSimpleToast,
} from "components/shared/Toasts";

export async function action() {
    await renderLoadingProgressToast(axios.post("account/resend-confirmation"));

    renderSimpleToast("Confirmation email resent.");

    return null;
}

const InactiveAccount = () => {
    const submit = useSubmit();

    const onResend = async () => {
        await submit(null, { method: "post", encType: "application/json" });
    };

    return (
        <div className="text-center">
            <h1>Welcome!</h1>
            <br />
            <p>
                You have not confirmed your account. Please check your inbox
                (and your spam folder) - you should have received an email with
                a confirmation link.
            </p>
            <p>
                Didn't get the email?
                <button
                    type="button"
                    className="btn btn-link p-0 align-baseline"
                    style={{ marginLeft: "4px" }}
                    onClick={onResend}
                >
                    Resend
                </button>
                .
            </p>
        </div>
    );
};

export default InactiveAccount;
